import script from "./other-modbus-definition.vue?vue&type=script&setup=true&lang=js"
export * from "./other-modbus-definition.vue?vue&type=script&setup=true&lang=js"

import "./other-modbus-definition.vue?vue&type=style&index=0&id=02ea6b36&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02ea6b36"]])

export default __exports__